import { useMutation, useQueryClient } from '@tanstack/react-query';
import { productKeys } from '@/features/products/hooks/useProductsQuery';
import {
    clearProductFeePayerPairOverride,
    setProductFeePayerPairOverride,
    type PayerPairOverridePayload,
} from '../services/productFees';
import { productFeeKeys } from './useProductFeesQuery';

export function usePayerPairOverrideMutations(productId: string) {
    const qc = useQueryClient();

    const invalidate = () => {
        qc.invalidateQueries({ queryKey: productFeeKeys.list(productId) });
        qc.invalidateQueries({ queryKey: productKeys.detail(productId) });
    };

    const setMutation = useMutation({
        mutationFn: ({ id, payload }: { id: string; payload: PayerPairOverridePayload }) =>
            setProductFeePayerPairOverride(productId, id, payload),
        onSuccess: invalidate,
    });

    const clearMutation = useMutation({
        mutationFn: (id: string) => clearProductFeePayerPairOverride(productId, id),
        onSuccess: invalidate,
    });

    return { setMutation, clearMutation };
}
